var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import serverCrypto from 'crypto';
import { PHONE_NUMBER_REGEX } from '../enum/Constants';
export var isFromNext = function (url) {
    if (url === void 0) { url = ''; }
    return url.startsWith('/_next');
};
export var getHash = function (length) {
    if (length === void 0) { length = 10; }
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
        result += characters.charAt(getRandom(characters.length));
    }
    return result;
};
export var formatTime = function (time) {
    if (time <= 0)
        return '00:00';
    var roundedTime = Math.round(time);
    var minutes = Math.floor(roundedTime / 60);
    var seconds = "".concat(roundedTime % 60);
    return "".concat(minutes, ":").concat(seconds.padStart(2, '0'));
};
export var formatCount = function (count) {
    var units = ['', '만', '억', '조'];
    var str = "".concat(count);
    var i = Math.floor((str.length - 1) / 4);
    return Number(str.substring(0, str.length - i * 4)).toLocaleString() + units[i];
};
export function merge(obj1, obj2) {
    if (obj2 === void 0) { obj2 = {}; }
    var nObj = {};
    for (var _i = 0, _a = Object.entries(obj1); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], val1 = _b[1];
        var val2 = key in obj2 ? obj2[key] : null;
        if (val1 instanceof Object && val2) {
            nObj[key] = merge(val1, val2);
        }
    }
    return __assign(__assign(__assign({}, obj1), obj2), nObj);
}
export var validatePhoneNumber = function (str) {
    return PHONE_NUMBER_REGEX.test(str);
};
export var trimDigit = function (value, length) {
    var digit = value.replace(/\D/g, '');
    return digit.substring(0, length);
};
export var searchParams = function (params) {
    if (!params) {
        return '';
    }
    return Object.keys(params)
        .map(function (key) {
        return "".concat(encodeURIComponent(key)).concat(params[key] ? "=".concat(encodeURIComponent(params[key])) : "".concat(encodeURIComponent(params[key])));
    })
        .join('&');
};
export var getQueryString = function (params) {
    var str = searchParams(params);
    return str.length ? "?".concat(str) : '';
};
export var parseQueryString = function (search) {
    if (!search) {
        return {};
    }
    var qs = search.replace('?', '');
    var items = qs.split('&');
    return items.reduce(function (data, item) {
        var _a = item.split('='), key = _a[0], value = _a[1];
        var firstKey = items[0].split('=')[0];
        if (value) {
            data[key] = decodeURI(value.replace(/\+/g, ' '));
        }
        else {
            data[firstKey] = !item.includes('=')
                ? data[firstKey] + decodeURI("&".concat(item.replace(/\+/g, ' ')))
                : data[firstKey];
        }
        return data;
    }, {});
};
export var isNumber = function (value) { return !isNaN(value); };
export var multiply = function (num, multiple) {
    if (multiple === void 0) { multiple = 1; }
    return (isNumber(num) ? num * multiple : 0);
};
export var sum = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.reduce(function (a, b) { return a + b; });
};
export var someEqual = function (acc) {
    var arr = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        arr[_i - 1] = arguments[_i];
    }
    return arr.some(function (n) { return n === acc; });
};
export var returnSwitch = function (condition, trueValue, falseValue) {
    return (condition ? trueValue : falseValue);
};
export var checkBetween = function (_a, _b) {
    var targetStart = _a[0], targetEnd = _a[1];
    var compareStart = _b[0], compareEnd = _b[1];
    return targetStart < compareEnd && targetEnd > compareStart;
};
export var getBrMessage = function (message) {
    var nArray = [];
    var letter = '\n';
    nArray.push(message.split(letter)[0]);
    var br = message.indexOf(letter);
    var count = 0;
    if (br > -1) {
        while (br !== -1) {
            count++;
            nArray.push(message.split(letter)[count]);
            br = message.indexOf(letter, br + 1);
        }
    }
    return nArray;
};
export var validateCoupon = function (str) {
    return /^[A-za-z0-9]{8}$/g.test(str);
};
export var addClassToBody = function (classNames) {
    var classList = document.body.classList;
    classNames === null || classNames === void 0 ? void 0 : classNames.forEach(function (name) {
        if (!classList.contains(name)) {
            document.body.classList.add(name);
        }
    });
};
export var removeClassFromBody = function (classNames) {
    var classList = document.body.classList;
    classNames === null || classNames === void 0 ? void 0 : classNames.forEach(function (name) {
        if (classList.contains(name)) {
            document.body.classList.remove(name);
        }
    });
};
export var getRange = function (start, count) { return Array.from(Array(count)).map(function (_, i) { return i + start; }); };
var get32bitRandom = function () {
    var _a;
    if (typeof window !== 'undefined') {
        return Number((_a = (window.crypto || window.msCrypto)) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint32Array(1)));
    }
    return parseInt(serverCrypto.randomBytes(4).toString('hex'), 16);
};
// Math.random 대체 (0~size(미포함)) 정수 반환
export var getRandom = function (size) {
    return Math.floor((get32bitRandom() / Math.pow(2, 32)) * size);
};
// Fisher-Yates shuffle
export var getSuffled = function (arr) {
    var _a;
    var result = __spreadArray([], arr, true);
    for (var i = 0; i < result.length; i++) {
        var x = getRandom(result.length - i) + i;
        _a = [result[x], result[i]], result[i] = _a[0], result[x] = _a[1];
    }
    return result;
};
export var getRandomColors = function () {
    var randoms = [
        '#9B021B,#C1201E,#894F4F,#C37F83,#CB9E47',
        '#A88977,#675D5D,#A1A01A,#7C9422,#445906',
        '#236836,#4AB18F,#227F83,#429DB0,#50859F',
        '#4B9FCF,#074458,#2445FF,#1E3866,#717198',
        '#473B61,#6F287F,#A378FC,#DE7AA6,#CB5166',
        '#231917,#25271A,#4D5954,#4F585C,#213B32',
    ];
    return getSuffled("".concat(randoms).split(','));
};
export var parseToArray = function (data) {
    if (!data) {
        return [];
    }
    return JSON.parse(data);
};
export var getCreatorPath = function (item) {
    if (item.type === 'CREATOR') {
        return "/creator/".concat(item.uniqueValue);
    }
    if (item.type === 'ARTIST_MGR') {
        return "/tag?artistIds=".concat(item.id, "&title=").concat(encodeURIComponent(item.name));
    }
    if (item.type === 'CP') {
        return "/tag?contentsProviderIds=".concat(item.id, "&title=").concat(encodeURIComponent(item.name));
    }
    return '/';
};
/**
 * @param inserts 갭마다 삽입할 배열
 * @param list 갭만큼 자를 배열
 * @param gap 갭
 * @returns T[] list의 gap 마다 inserts 한 요소씩 끼워넣은 리스트 반환
 */
export var getInsertedListByGap = function (inserts, list, gap) {
    return inserts.reduce(function (prev, cur, index) {
        var endIndex = index + 1 >= inserts.length ? undefined : (index + 1) * gap;
        return __spreadArray(__spreadArray(__spreadArray([], prev, true), [cur], false), list.slice(index * gap, endIndex), true);
    }, []);
};
export var sleep = function (ms) {
    if (ms === void 0) { ms = 100; }
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(true); }, ms); });
};
